import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "slick-carousel/slick/slick";

import "../assets/css/pages/Home.css";
import "../assets/css/Responsive/Home_Responsive.css";

import quoteIcon from "../assets/images/Home/quotes.svg";
import visitorLines from "../assets/images/Home/visitor_lines.svg";

export default function Testimonial({ data }) {
    const sliderRef = useRef(null);

    useEffect(() => {
        if (!data || !data.slides) return;

        const $slider = $(sliderRef.current);
        if (!$slider.length || !$.fn?.slick) return;

        const applyQuoteEqualHeight = () => {
            const $quotes = $slider.find(".slick-slide:not(.slick-cloned) .equal_height");
            if (!$quotes.length) return 0;

            $quotes.css("height", "auto");

            let maxQuoteHeight = 0;
            $quotes.each(function () {
                const h = $(this).outerHeight();
                if (h > maxQuoteHeight) maxQuoteHeight = h;
            });

            if (maxQuoteHeight > 0) {
                $quotes.css("height", `${maxQuoteHeight}px`);
            }

            console.log("[Testimonial] equal_height applied", {
                quoteCount: $quotes.length,
                maxQuoteHeight,
            });

            return maxQuoteHeight;
        };

        const clearInlineHeights = () => {
            $slider.find(".equal_height").css("height", "");
            $slider.find(".t-photo").css({
                height: "",
                maxHeight: "",
            });
        };

        const syncCardAndPhotoHeights = () => {
            const $cards = $slider.find(".slick-slide:not(.slick-cloned) .t-card");
            const $photos = $slider.find(".slick-slide:not(.slick-cloned) .t-photo");

            $photos.css({
                height: "auto",
                maxHeight: "none",
            });

            if (!$cards.length || !$photos.length) {
                console.log("[Testimonial] sync skipped", {
                    cards: $cards.length,
                    photos: $photos.length,
                });
                return;
            }

            const cardHeights = [];
            let maxCardHeight = 0;
            $slider.addClass("is-card-measuring");
            $cards.each(function () {
                const h = $(this).outerHeight();
                cardHeights.push(h);
                if (h > maxCardHeight) maxCardHeight = h;
            });
            $slider.removeClass("is-card-measuring");

            if (maxCardHeight > 0) {
                $photos.css({
                    height: `${maxCardHeight}px`,
                    maxHeight: `${maxCardHeight}px`,
                });
            }

            console.log("[Testimonial] card/photo sync", {
                cardHeights,
                maxCardHeight,
                appliedToPhotos: $photos.length,
            });
        };

        const applyEqualHeight = () => {
            const isDesktop = window.innerWidth > 1024;
            if (!isDesktop) {
                clearInlineHeights();
                return;
            }

            applyQuoteEqualHeight();
            // Run in next frame so card layout reflects quote equalization first.
            window.requestAnimationFrame(() => {
                syncCardAndPhotoHeights();
            });
        };

        $slider.on("init reInit afterChange setPosition breakpoint", () => {
            applyEqualHeight();
        });

        if ($slider.length > 0 && !$slider.hasClass("slick-initialized")) {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3500,
                arrows: true,
                dots: true,
                fade: true,
                speed: 1000,
                cssEase: "linear",
                pauseOnHover: false,
                appendArrows: ".t-wrap",
                customPaging: () => '<span class="t-dot"></span>',
                prevArrow:
                    '<button type="button" class="t-arrow t-arrow--prev" aria-label="Previous"><span class="t-arrow-circle"><svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);"><path d="M5.85355 2.64645C5.756 2.56425 5.63155 2.51631 5.50245 2.51832C5.37339 2.52028 5.251 2.57126 5.16113 2.66113C5.07126 2.751 5.02028 2.87339 5.01832 3.00245C5.01631 3.13155 5.06425 3.256 5.14645 3.35355C5.29897 3.53436 5.4522 3.71446 5.60614 3.89386C6.99159 5.50841 8.43431 7.06569 9.93431 8.56569V7.43431C8.43431 8.93431 6.99159 10.4916 5.60614 12.1061C5.4522 12.2855 5.29897 12.4656 5.14645 12.6464C5.06425 12.744 5.01631 12.8684 5.01832 12.9976C5.02028 13.1266 5.07126 13.249 5.16113 13.3389C5.251 13.4287 5.37339 13.4797 5.50245 13.4817C5.63155 13.4837 5.756 13.4357 5.85355 13.3536C6.03436 13.201 6.21446 13.0478 6.39386 12.8939C8.00841 11.5084 9.56569 10.0657 11.0657 8.56569C11.3857 8.24569 11.3857 7.75431 11.0657 7.43431C9.56569 5.93431 8.00841 4.49159 6.39386 3.10614C6.21446 2.9522 6.03436 2.79897 5.85355 2.64645Z"/></svg></span></button>',
                nextArrow:
                    '<button type="button" class="t-arrow t-arrow--next" aria-label="Next"><span class="t-arrow-circle"><svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.85355 2.64645C5.756 2.56425 5.63155 2.51631 5.50245 2.51832C5.37339 2.52028 5.251 2.57126 5.16113 2.66113C5.07126 2.751 5.02028 2.87339 5.01832 3.00245C5.01631 3.13155 5.06425 3.256 5.14645 3.35355C5.29897 3.53436 5.4522 3.71446 5.60614 3.89386C6.99159 5.50841 8.43431 7.06569 9.93431 8.56569V7.43431C8.43431 8.93431 6.99159 10.4916 5.60614 12.1061C5.4522 12.2855 5.29897 12.4656 5.14645 12.6464C5.06425 12.744 5.01631 12.8684 5.01832 12.9976C5.02028 13.1266 5.07126 13.249 5.16113 13.3389C5.251 13.4287 5.37339 13.4797 5.50245 13.4817C5.63155 13.4837 5.756 13.4357 5.85355 13.3536C6.03436 13.201 6.21446 13.0478 6.39386 12.8939C8.00841 11.5084 9.56569 10.0657 11.0657 8.56569C11.3857 8.24569 11.3857 7.75431 11.0657 7.43431C9.56569 5.93431 8.00841 4.49159 6.39386 3.10614C6.21446 2.9522 6.03436 2.79897 5.85355 2.64645Z"/></svg></span></button>',
            });
        }

        // ✅ Handle window resize
        const handleResize = () => {
            applyEqualHeight();
        };

        window.addEventListener("resize", handleResize);

        // Initial setup
        setTimeout(applyEqualHeight, 300);

        return () => {
            window.removeEventListener("resize", handleResize);
            $slider.off("init reInit afterChange setPosition breakpoint");
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        };
    }, [data]);

    if (!data) return null;

    const slides = Array.isArray(data.slides) ? data.slides : [];

    return (
        <section className="t-section">
            <div className="canvas">
                <div className="t-wrap">
                    <div className="t-title">
                        <span className="t-eyebrow">{data.eyebrow}</span>
                        <h2 className="t-h2">{data.title}</h2>
                    </div>

                    <div className="t-slider" ref={sliderRef}>
                        {slides.map((item, index) => (
                            <div className="t-slide" key={index}>
                                <div className="t-row">
                                    <div className="t-photo">
                                        <img src={item.image?.url} alt={item.author} />
                                    </div>

                                    <article className="t-card">
                                        <p className="t-quote equal_height">{item.quote}</p>

                                        <div className="quote-image">
                                            <div className="quote-image-inner">
                                                <p className="t-author">{item.author}</p>
                                                <div className="rating">
                                                    {[...Array(5)].map((_, i) => (
                                                        <svg key={i} width="24" height="24" viewBox="0 0 24 24">
                                                            <path
                                                                d="M12 17.27L16.9626 20.2652C17.417 20.5395 17.9775 20.1321 17.857 19.6152L16.54 13.97L20.9252 10.1711C21.3263 9.82361 21.1119 9.16465 20.583 9.11978L14.81 8.63L12.5524 3.30342C12.3457 2.81561 11.6543 2.8156 11.4476 3.30342L9.19 8.63L3.41698 9.11978C2.88812 9.16465 2.67368 9.82361 3.07484 10.1711L7.46 13.97L6.14305 19.6152C6.02247 20.1321 6.58301 20.5395 7.0374 20.2652L12 17.27Z"
                                                                fill={i < (parseInt(item.rating) || 0) ? "#FEBC2F" : "#E0E0E0"}
                                                            />
                                                        </svg>
                                                    ))}
                                                </div>
                                            </div>
                                            <img src={quoteIcon} alt="quote" />
                                        </div>
                                    </article>
                                </div>
                            </div>
                        ))}
                    </div>

                    <img src={visitorLines} alt="Decorative lines" className="linesx" />
                </div>
            </div>
        </section>
    );
}